<div class="d-flex flex-column h-100">
  <div class="bgcomp d-flex flex-column mh-100 pb-3">
    <div class="d-flex mx-3 pt-3">
      <div class="d-flex align-items-center mr-auto">
        <app-keyword-search
          id="referral-keyword-search"
          (keywords)="onUpdatingKeywords($event)"
          [currentSiteChangedEvent]="clearSearch$"
          [dashboardName]="'Referrals'"
        ></app-keyword-search>
        <div
          *ngIf="hasReferralsAwaitingAcknowledgement"
          id="label-referral-awaiting-ack"
        >
          Referrals are Awaiting Acknowledgement. If you need help finding them,
          update your filter settings.
        </div>
      </div>
      <div *ngIf="filtersApplied$ | async" class="clear-filter-box">
        <button
          mat-stroked-button
          id="referral-clear-filter-btn"
          (click)="clearFilters()"
        >
          <mat-icon>delete_outline</mat-icon>
          Clear Filters
        </button>
      </div>
      <div class="mx-3 date-filter-box">
        <app-date-range-picker
          id="referral-date-range-picker"
          [initialRangeValue]="filterTimeRange$ | async"
          (selectedRangeValueChange)="filterTimeRangeChange($event)"
        >
        </app-date-range-picker>
      </div>
      <div>
        <button
          type="button"
          mat-stroked-button
          id="referral-filter-btn"
          (click)="openFilters()"
        >
          Filters
        </button>
        <app-referral-filters
          id="referral-filters-menu"
          [visible]="filtersVisibleSource | async"
          (closePopout)="closeFilters()"
        ></app-referral-filters>
      </div>
    </div>

    <div class="my-2 mx-3">
      <hr class="container-divider" *ngIf="!loading" />
      <mat-progress-bar
        *ngIf="loading"
        id="referral-loading-progress-bar"
        mode="indeterminate"
      ></mat-progress-bar>
    </div>

    <app-referral-table
      id="table-referrals"
      class="custom-scrollbar overflow-auto h-100"
      [referralList]="referralDataSource"
      [filtersApplied]="filtersApplied$ | async"
      (visualRowSizeChanged)="onVisualRowSizeChanged($event)"
      (rowActioned)="onRowActioned()"
    ></app-referral-table>
  </div>
</div>
